var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"close-on-click-modal":false,"custom-class":"qr","visible":_vm.visibleInner,"append-to-body":""},on:{"update:visible":function($event){_vm.visibleInner=$event}}},[_c('qr-code',{attrs:{"text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }